module.exports = __webpack_public_path__ + "static/hero-dd6ccd54f762c7625a1f2079bae3f6e3.jpg";